import { Box } from '@chakra-ui/react';

import { FormLoader } from '$components/FormLoader';
import { PaidLoader } from '$components/PaidLoader';
import { ToastError } from '$components/ToastError';
import { useIsDesktop } from '$src/hooks/client/useIsDesktop';
import { useCheckoutFeaturesAtom } from '$src/hooks/state/useCheckoutFeaturesAtom';

interface LoadingWrapperProps {
  children: React.ReactNode;
  isLoading: boolean;
  isPaidLoading: boolean;
}

export const LoadingWrapper = ({ isLoading, isPaidLoading, children }: LoadingWrapperProps) => {
  const { canUseCheckoutFeature } = useCheckoutFeaturesAtom();
  const { isMobile } = useIsDesktop();

  return (
    <>
      {isLoading && <FormLoader />}
      {isPaidLoading && <PaidLoader />}
      <ToastError />
      <Box
        overflow="hidden"
        flexDirection={'column'}
        display={isLoading ? 'none' : 'flex'}
        h="full"
        bg={canUseCheckoutFeature('show_mobile_background_image') && isMobile ? undefined : 'var(--bg, #FFF)'}
      >
        {children}
      </Box>
    </>
  );
};
